module.exports = __webpack_public_path__ + "img/aaron-griffin-sketch-series-1.6dc3238.jpg";